import React from 'react';
import {Banner} from 'src/v2/components/common/Banner';
import {getStore} from 'src/v2/state/store';

export const ErrorBanner: React.FC = () => {
  const store = getStore();

  const errorBanner = store.useSelector((state) => state.errorBanner);

  if (!errorBanner) {
    return null;
  }

  return <Banner message={errorBanner.message} variant="error" />;
};
